import { g as t } from "./index793.mjs";
import { d as i } from "./index837.mjs";
import { w as s } from "./index760.mjs";
import { d as n } from "./index795.mjs";
var a = t, c = i, l = s, f = n, e = l("species"), S = function(o) {
  var r = a(o);
  f && r && !r[e] && c(r, e, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
};
export {
  S as s
};
